export const onboardingTopics: Record<string, any> = {
    'why make nft art?': (
        <div>
            <p>
                <a href="https://en.wikipedia.org/wiki/Non-fungible_token" target="_blank" rel="noreferrer">NFTs</a>
                <span> are an emerging form of data storage intended to certify uniqueness. </span>
                <span>In the same way that there is only one </span>
                <a href="https://en.wikipedia.org/wiki/Mona_Lisa" target="_blank" rel="noreferrer">Mona Lisa</a>
                <span> and many copies of it, </span>
                there are many advantages in using a modern form of digital representation for art exchange:
            </p>
            <ul>
                <li>Your original work is <span className="text-light">preserved in time</span>, for as long as the blockchain exists</li>
                <li>Your <span className="text-light">intellectual rights</span> as an artist are guaranteed</li>
                <li>
                    You will <span className="text-light">earn royalties</span>
                    <span> every time your work moves to different hands, even after the first sale </span>
                    (<span className="text-avenir-db text-light">NFTY </span>
                    guarantees partners a 10% commission on each sale)
                </li>
            </ul>
            <p>
                <span>We encourage you to research the technology and decide for yourself if </span>
                <a href="https://hackernoon.com/nfts-exploring-infrastructure-usability-role-in-defi-and-questions-about-ownership-ba8y341f" target="_blank" rel="noreferrer">NFTs represent a reliable future</a>
                <span> for artists today.</span>
            </p>
            <p className="text-center text-light">We think it does.</p>
        </div>
    ),
    'why our platform?': (
        <div>
            <p>
                <span>There is already an incredible and quickly growing </span>
                <a href="https://opensea.io/" target="_blank" rel="noreferrer">Open Sea</a>
                <span> of NFTs to be found on the internet. </span>
                We expect this market to
                <span className="text-light"> continue to grow </span>
                as more and more artists adopt technology to protect their work.
                Just as the
                <span className="text-light"> transition from physical to digital </span>
                has permeated every medium of art out there.
            </p>
            <ul>
                <li>
                    <span className="text-avenir-db text-light">NFTY </span>cultivates an
                    <span className="text-light"> exclusive audience </span>
                    of collectors through a scarcity-driven approach to art.
                    Remember, there is only ONE Mona Lisa in existence.
                </li>
                <li>
                    We offer a
                    <span className="text-light"> growing userbase </span>
                    that can give you sustained engagement for your own projects
                </li>
                <li>
                    You don't need to know a thing about NFTs, or even be concerned about the long term potential they have to offer.
                    <span className="text-light"> We will handle everything for you</span>,
                    from setup to minting of your work.
                </li>
            </ul>
        </div>
    ),
    'will this cheapen my work?': (
        <div>
            <p>The short answer is, <span className="text-light">no</span>.</p>
            <p>The concern, however, is valid. There are lots of copycats and thieves in the wild west of the internet, but we are here for the real thing:</p>
            <ul>
                <li><span className="text-avenir-db text-light">NFTY </span>is not interested in cheap clones or mass produced art</li>
                <li>
                    We carefully consider
                    <span className="text-light"> each potential partner </span>
                    and only choose the ones that offer real value, both for our platform as well as other partner artists
                </li>
                <li>We believe we can offer you and our patrons peace of mind and a unique experience through transparency and quality</li>
            </ul>
        </div>
    ),
    'do I have what it takes?': (
        <div>
            <p>
                Let's face it,<span className="text-light"> it's not easy being an artist</span>. There is a lot of competition,
                and it doesn't always pay the bills. While it would be great to make a deal with everyone who approaches us,
                in order to provide maximum value to all parties involved, we are forced to apply a somewhat
                <span className="text-light"> strict approach to parner selection</span>.
            </p>
            <p>
                Without making any guarantees, here are some considerations regarding our process:
            </p>
            <ul>
                <li>We look at each artist's portfolio and past works</li>
                <li>Your current influence is an aspect of our decision making, but we understand that new artists do not have the luxury of large followings</li>
                <li>The personality you display through your creative work is important to us</li>
                <li>The works you decide to submit to us are evaluated on aesthetic means</li>
                <li>We do not accept pornographic or deliberately violent work by any means</li>
            </ul>
        </div>
    ),
    'what about the environment?': (
        <div>
            <p>
                We understand the entire world of crypto is under scrutiny for the potential environmental impact it could have.
                <span className="text-light"> And we agree that it should be.</span>
                <span> We also encourage our audience to consider the impact of the current worldwide banking system, and compare the two as competing systems, because they are.</span>
            </p>
            <p>
                <span>As an emerging technology that is driven by competition, blockchain solutions </span>
                <a href="https://hackernoon.com/an-opportunity-for-clean-energy-through-the-ethereum-blockchain-tk903a7w" target="_blank" rel="noreferrer">are driving renewables</a>
                <span> and starting more conversations of the true cost of currency.</span>
            </p>
            <p>As mentioned previously, we encourage you to research and decide for yourself to find where you stand. Here are some interesting links to get you started:</p>
            <ul>
                <li>
                    <a href="https://www.blockchainforclimate.org/our-vision" target="_blank" rel="noreferrer">Blockchain for Climate</a>
                </li>
                <li>
                    <a href="https://medium.com/superrare/no-cryptoartists-arent-harming-the-planet-43182f72fc61" target="_blank" rel="noreferrer">A thoughtful article on Medium about NFTs</a>
                </li>
                <li>
                    <a href="https://www.jbs.cam.ac.uk/wp-content/uploads/2021/01/2021-ccaf-3rd-global-cryptoasset-benchmarking-study.pdf" target="_blank" rel="noreferrer">Cambridge University Analysis of Crypto Asset Consumption</a>
                </li>
                <li>
                    <a href="https://lo3energy.com/" target="_blank" rel="noreferrer">LO3 Energy Independence</a>
                </li>
                <li>
                    <a href="https://news.bitcoin.com/bitcoin-energy-consumption-is-far-more-efficient-and-greener-than-todays-banking-system/" target="_blank" rel="noreferrer">Bitcoin v. Today's banking System</a>
                </li>
            </ul>

        </div>
    )
};

export const defaultKey = 'why make nft art?';
